import { observer } from 'mobx-react'
import { FC, useEffect } from 'react'
import styles from './index.module.scss'
import { useStores } from '../../../utils'
import { ProfileCompletionPromotionPopupContent } from '../../molecules/ProfileCompletionPromotionPopupContent'
import { IViewer } from '../../../types'

type Props = {
  type: 'jobSeeker' | 'investor' | 'startup'
}

export const ProfileCompletionPromotionPopup: FC<Props> = observer(({ type }) => {
  const { ui, viewer } = useStores()

  useEffect(() => {
    if (shouldShow(type, viewer.viewer) && ui.isProfileInputModalOpen === false) {
      ui.toggleProfileInputModal()
    }
  }, [viewer.isInitialized])

  return (
    <div className={styles.container} style={ui.isProfileInputModalOpen ? {} : { display: 'none' }}>
      <div className={styles.modal}>
        <div className={styles.card}>
          <ProfileCompletionPromotionPopupContent type={type} />
        </div>
      </div>
    </div>
  )
})

function shouldShow(type: string, viewer: IViewer): boolean {
  const isShowingForJobSeeker =
    viewer.profile?.isJobSeeker && viewer.basicProfileCompletionRate < 50 && viewer.jobSeekerProfileCompletionRate < 50

  const isShowingForInvestor =
    (viewer.profile?.isInvestor || viewer.profile?.isAngel) &&
    viewer.basicProfileCompletionRate < 50 &&
    viewer.investorProfileCompletionRate < 50

  const isShowingForStartup = viewer.companyMembers?.some(
    (companyMember) =>
      !companyMember.company.isVc &&
      viewer.getMyCompanyBySlug(companyMember.company.slug).basicProfileCompletionRate < 50 &&
      viewer.getMyCompanyBySlug(companyMember.company.slug).startupProfileCompletionRate < 50
  )

  return (
    (type === 'jobSeeker' && isShowingForJobSeeker) ||
    (type === 'investor' && isShowingForInvestor) ||
    (type === 'startup' && isShowingForStartup)
  )
}
